import React from 'react';

import Blog from '../board/blog';
import Sidebar from '../board/sidebar';

class News extends React.Component {

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
    }

    render() {
        return (
            <div className="container g-pt-30 g-pb-60">
                <div className="row">
                    <Sidebar />
                    <Blog />
                </div>
            </div>
        )
    }
}

export default News;


// WEBPACK FOOTER //
// ./src/pages/front/library/news.js